export const BASE_MAP_LAYER_ID = 'mapstack-layer'
export const PROMOTED_COLUMN_ID = 'msuuid'
export const GEOJSON_SOURCE = 'geojson-source'
export const VT_SERVER_SOURCE = 'vt-source'
